import {disputasCompraDireta, formatosDefault, mensagens, portes, tiposCompraDireta, situacoesCompraDireta, keysDomainException} from '@/core/constants'

export default {
    data() {
        return {
            formatosDefault,
            disputasCompraDireta,
            mensagens,
            portes,
            tiposCompraDireta,
            situacoesCompraDireta,
            keysDomainException
        }
    },
    methods: {
        formatarLista(constant) {
            const list= Object.getOwnPropertyNames(constant).sort()
            if (list.indexOf('__ob__') >= 0) {
                list.splice(list.indexOf('__ob__'), 1)
            }
            return list
        }
    }
}
